import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { StorageHandler } from 'src/app/shared/handlers/storage-handler';

@Injectable({
    providedIn: 'root'
})
export class AccessHandler {

    constructor() { }

    createAccessItem(name: string, value: string, hours: number): void {
        if (!hours) {
            hours = 24;
        }
        const expiresAt = moment().add(hours, 'hours');
        StorageHandler.setLocalStorage(name, value);
        StorageHandler.setLocalStorage(name + 'expires_at', JSON.stringify(expiresAt.valueOf()));
    }

    readAccessItem(name: string): any {
        const accessItem = StorageHandler.getLocalStorage(name);
        if (this.isLoggedIn(name)) {
            if (accessItem) {
                return accessItem;
            }
        } else {
            this.deleteAccessItem(name);
        }
        return null;
    }

    deleteAccessItem(name: string): void {
        localStorage.removeItem(name);
        StorageHandler.removeLocalStorage(name + 'expires_at');
    }

    isLoggedIn(name: string): boolean {
        return moment().isBefore(this.getExpiration(name));
    }

    getExpiration(name: string): any {
        const expiration = StorageHandler.getLocalStorage(name + 'expires_at');
        const expiresAt = JSON.parse(expiration);
        return moment(expiresAt);
    }

}
